import type { Flashcard } from "../../pages/chapterDetails/revise/memory-card/types/memoryApiTypes";

export function flashcardStableKey(card: Flashcard, index: number): string {
  if (card.flashcardId != null) return `fc-${card.flashcardId}`;
  if (card.memoryCardId != null) return `mc-${card.memoryCardId}`;
  return `idx-${index}`;
}

export function flashcardFrontText(card: Flashcard): string {
  const fromFront = card.front?.text?.trim();
  if (fromFront) return fromFront;
  return card.title?.trim() ?? "";
}

export function flashcardBackText(card: Flashcard): string {
  const fromBack = card.back?.text?.trim();
  if (fromBack) return fromBack;
  const desc = card.description?.trim();
  if (desc) return desc;
  const summary = card.summary?.trim();
  if (summary) return summary;
  return "No answer available";
}
